module.exports = __webpack_public_path__ + "static/TT1383_Logo01-1cf2c3cb1fa525ca2f4d68373160d27e.png";